import React, {Suspense, useState} from 'react'
import {useImage} from 'react-image'
// import IconButton from "@mui/material/IconButton";
// import {CircularProgress, Dialog} from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
// import {useDispatch, useSelector} from "react-redux";
// import {removeImageFromQuote} from "../reducers/cartSlice";
import fileDownload from "js-file-download";
import {Modal} from "react-bootstrap";

// import {startLoading, stopLoading} from "../reducers/loadingSlice";

function normalizeFileType(fileType) {
    if (!fileType) {
        return "";
    }

    return fileType
        .toString()
        .trim()
        .toLowerCase()
        .replace(/^\./, "")
        .replace(/^(image|video)\//, "");
}

function isImageFile(image_type) {
    const normalizedType = normalizeFileType(image_type);
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "webp", "svg", "heic", "heif"];
    return imageExtensions.includes(normalizedType);
}

function isVideoFile(image_type) {
    const normalizedType = normalizeFileType(image_type);
    const videoFileExtensions = [
        "mp4",
        "avi",
        "x-msvideo",
        "x-matroska",
        "quicktime",
        "x-ms-wmv",
        "x-flv",
        "webm",
        "mpeg",
        "3gpp",
        "x-m4v",
        "vnd.rn-realmedia",
        "x-matroska",
        "vnd.dlna.mpeg-tts",
        "ogg",
    ];
    return videoFileExtensions.includes(normalizedType);
}

function MyImageComponent(props) {

    const {item, handleImageClick, isDownloading, isReadOnly, isSelected, onToggleSelect} = props

    const [isLoading, setIsLoading] = useState(false)

    let srcList = [item.thumbnail_url, item.download_url, '/loading.gif']
    if (!isImageFile(item.image_type)) {
        if (isDownloading) {
            srcList = ['/loading.gif']
        } else {
            if (isVideoFile(item.image_type)) {
                srcList = ['/video.png']
            } else {
                srcList = ['/attachment.png']
            }
        }
    }

    const {src, isLoadingImage} = useImage({
        srcList: srcList
    })

    return (

        <div style={{position: 'relative'}}>
            {isLoadingImage ? 'Loading...' :
                <div style={{textAlign: 'center'}}>
                    <img
                        src={src}
                        alt="Image"
                        width={100}
                        height={100}
                        onClick={(event) => {
                            handleImageClick(event);
                        }}
                        style={{cursor: isLoading ? 'disabled' : 'pointer'}}
                    />
                    {/*<div style={{marginTop: 5, width: 120,}}> /!* Adjust marginTop as needed *!/*/}
                    {/*    {item.title}*/}
                    {/*</div>*/}
                </div>}
            {!isReadOnly && onToggleSelect &&
                <input
                    type="checkbox"
                    aria-label={`Select image ${item.title || item.id}`}
                    checked={!!isSelected}
                    onClick={(event) => event.stopPropagation()}
                    onChange={() => onToggleSelect(item.id)}
                    style={{
                        position: 'absolute',
                        top: '4px',
                        left: '4px',
                        width: '18px',
                        height: '18px',
                        cursor: 'pointer',
                        zIndex: 2,
                    }}
                />}
        </div>
    )
}

export default function ImageComponent(props) {
    const {item, isReadOnly, isSelected, onToggleSelect} = props;
    const [showDialog, setShowDialog] = useState(false);
    // const isLoading = useSelector((state) => state.loading.backend)
    const [isLoading, setIsLoading] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false)


    async function handleImageClick(event) {
        event.stopPropagation()
        if (isLoading) return


        if (isImageFile(item.image_type)) {
            toggleDialog()
        } else {
            setIsDownloading(true)
            const title = item.title || 'untitled';
            const response = await fetch(item.download_url);
            const blob = await response.blob();
            fileDownload(blob, title);
            setIsDownloading(false)
        }


    }

    const toggleDialog = (event) => {
        setShowDialog((prevState) => !prevState);
    };

    return (
        <>
            <Suspense>
                <MyImageComponent handleImageClick={handleImageClick} item={item}
                                  isReadOnly={isReadOnly}
                                  isDownloading={isDownloading}
                                  isSelected={isSelected}
                                  onToggleSelect={onToggleSelect}/>
            </Suspense>
            <div
                onClick={(e) => e.stopPropagation()}
            >
                <Modal show={showDialog} onHide={toggleDialog} onClick={toggleDialog}>
                    <img src={item.download_url} alt="Enlarged Image" style={{width: '100%'}}/>
                    {/*<IconButton*/}
                    {/*    aria-label="close"*/}
                    {/*    onClick={toggleDialog}*/}
                    {/*    style={{position: 'absolute', top: '10px', right: '10px', color: '#fff'}}*/}
                    {/*>*/}
                    {/*    <CloseIcon/>*/}
                    {/*</IconButton>*/}
                </Modal>
            </div>
        </>

    )
}
